import { useCallback, useEffect, useRef, useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { BASE_API, } from "../../../constants/api";
import { persianLanguage } from "../../../constants/persianTerms";
import { datagridCustomStore } from "../../../shared/devexpress";
import { successNotify } from "../../../shared/notifications";
import { Bounce, ToastContainer } from 'react-toastify';

import { Button, Tooltip } from "devextreme-react";
import { Popup, Position } from 'devextreme-react/popup';
import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  Pager,
  Paging,
  Scrolling,
  Selection,
} from 'devextreme-react/data-grid';
import { useNavigate } from "react-router-dom";
import ReceiptDetail from "../receipt-detail/receipt-detail";
import { onExporting } from "../../../shared/excel-export";
import ReceiptChangeApprovation from "../receipt-change-approvation/receipt-change-approvation";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { DEFAULT_DATAGRID_PAGE_SIZE } from "../../../constants/constant-numbers";
import { DATAGRID_ALLOWED_PAGE_SIZES } from "../../../constants/constant-arrays";

import faMessages from 'devextreme/localization/messages/fa.json';
import { locale, loadMessages } from 'devextreme/localization';
import { useDimension } from "../../custom-providers/dimension-provider/DimensionProvider";

locale('fa')
loadMessages(faMessages);


export const DatePickerInput = (props) => {
  return <input className="date-picker-input" {...props} />;
}


export default function ReceiptListDevextreme(){
    const auth = useAuth();
    const receiptsApi = `${BASE_API}receipts/devextreme/`;

    const {windowWidth} = useDimension();

    const [popupVisible, setPopupVisible] = useState(false);
    const [approvedPopupVisible, setApprovedPopupVisible] = useState(false);
    const [receipts, setReceipts] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [downloadable, setDownloadable] = useState(false);
    const [receiptId, setReceiptId] = useState(null);
    const [receipt, setReceipt] = useState(null);
    const [canChangeApprove, setCanChangeApprove] = useState(false);
    const [counter, setCounter] = useState();

    const [locale, setLocale] = useState('fa');

    const dataGridRef = useRef(null);

    const navigate = useNavigate();

    const change = (unix, formatted) => {
      console.log(unix); // returns timestamp of the selected value, for example.
      console.log(formatted); // returns the selected value in the format you've entered, forexample, "تاریخ: 1396/02/24 ساعت: 18:30".
    }
  
    const onSelectionChanged = (selectedRowData) => {
        setSelectedRowKeys(selectedRowData.selectedRowKeys);
        setSelectedRowData(selectedRowData);
        if(selectedRowData.selectedRowKeys.length === 1){
          setDownloadable(true)
          setCanChangeApprove(true);
        } else {
          setDownloadable(false);
          setCanChangeApprove(false);
        
        }
    };
  
      useEffect(() => {
          const data = datagridCustomStore('id', receiptsApi);
          setReceipts(data);
      }, [
        receiptsApi,
        counter, 
      ]);
            
      const onDetail = () => {
        setPopupVisible(true);
        setReceiptId(selectedRowData['selectedRowsData'][0]['id']);
        setReceipt(selectedRowData['selectedRowsData'][0]);
      }

      const onNew = () => {
        navigate('/receipts/new');
      }

      const refreshDataGrid = () => {
        dataGridRef.current.instance.refresh().then( res =>{
          successNotify(persianLanguage.phrase.refresh.SUCCESSFUL_REFRESH)
        })
        .catch( error => {});
      };
      
      const downloadAttachmentByUrl = (url, name) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          name,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);        
      }

      const attachmentLink = (e)  =>{
        onDetail()
      }
      const downloadAttachment = () => {
        downloadAttachmentByUrl(selectedRowData['selectedRowsData'][0]['attachmentUrl'],
          selectedRowData['selectedRowsData'][0]['attachmentName']
        )
      }

      const hideInfo = () => {
        setCounter(prev=>prev+1);
        setPopupVisible(false);
        setReceiptId(null);
      };
      
      const onApprovedClick = () => {
        if(selectedRowKeys.length === 1){
          setApprovedPopupVisible(true);
          setReceipt(selectedRowData['selectedRowsData'][0]);
        }
      }
  
      const approvePopupToParent = (value) => {
        setApprovedPopupVisible(value);
        const data = datagridCustomStore('id', receiptsApi);
        setReceipts(data);
        refreshDataGrid();        
      };
    
      const [selectedDay, setSelectedDay] = useState(null);

      return (
        <div>
          <div>
          
            <ToastContainer
              rtl={true}
              position="bottom-left"
              theme="dark"
              draggable
              transition={Bounce} 
            />
          </div>
          <div className="m-5">
          <Button
            id='newReceiptId'
            // type="success"
            text={persianLanguage.phrase.receipt.NEW_RECEIPT}
            icon="plus"
            className='no-border-btn no-border-radius bg-primary-main black box-shadow-0-4-4-0'
            onClick={() => onNew()}
            stylingMode="contained"
          />
          {auth?.user?.isAdmin === true
          &&

          <>
          <Button
            id='receiptDetailId'
            text={persianLanguage.phrase.receipt.RECEIPT_DETAIL}
            icon="info"
            disabled={!downloadable}
            className='no-border-btn no-border-radius bg-primary-main black box-shadow-0-4-4-0'
            onClick={() => onDetail()}
            stylingMode="contained"
          />
          <Button
            id='receiptAttachmentUrl'
            text={persianLanguage.phrase.receipt.DOWNLOAD_RECEIPT}
            icon="download"
            disabled={!downloadable}
            className='no-border-btn no-border-radius bg-primary-main black box-shadow-0-4-4-0'
            onClick={() => downloadAttachment()}
            stylingMode="contained"
          />


          </>
          }

          <Tooltip
            target="#newReceiptId"
            showEvent="mouseenter"
            hideEvent="mouseleave"
            hideOnOutsideClick={false}
          >
            <div>{persianLanguage.phrase.receipt.NEW_RECEIPT}</div>
          </Tooltip>
          <Tooltip
            target="#receiptDetailId"
            showEvent="mouseenter"
            hideEvent="mouseleave"
            hideOnOutsideClick={false}
          >
            <div>{persianLanguage.phrase.receipt.RECEIPT_DETAIL}</div>
          </Tooltip>
          <Tooltip
            target="#receiptAttachmentUrl"
            showEvent="mouseenter"
            hideEvent="mouseleave"
            hideOnOutsideClick={false}
          >
            <div>{persianLanguage.phrase.receipt.DOWNLOAD_RECEIPT}</div>
          </Tooltip>
          </div>      

            {/* <div className="grid grid-cols-3 m-3 date-picker-block" >
              <div className="grid grid-cols-2 m-3">
                <span>از</span>
              <DatePicker
                inputComponent={DatePickerInput}
                placeholder="انتخاب تاریخ"
                format="jYYYY/jMM/jDD"
                onChange={change}
                id="datePicker"
                preSelected="1396/05/15"
              />
              </div>
              <div></div>
              <div></div>
            </div> */}
          {auth?.user?.isAdmin &&
          
          <div className='m-5'>
            <DataGrid
              id="grid-container"
              keyExpr="id"
              className=" user-select-none custom-datagrid-bg"
              onRowDblClick={attachmentLink}
              dataSource={receipts}
              ref={dataGridRef}
              rtlEnabled={true}
              onSelectionChanged={onSelectionChanged}
              selectedRowKeys={selectedRowKeys}
              selectedRowData={selectedRowData}
              locale={navigator.language}
              showBorders={true}
              allowColumnResizing={true}
              columnHidingEnabled={true}
              onExporting={onExporting}
              remoteOperations={true}
            >
              <Scrolling columnRenderingMode="virtual" />
              <Export enabled={true} allowExportSelectedData={true} />  
              <Selection mode="multiple"/>
              <FilterRow visible={true} />
              <Paging 
                defaultPageSize={DEFAULT_DATAGRID_PAGE_SIZE}
                showTitle={true}
                title={'dwd'}
                text={'dwd'}
              />
              <Pager
                showPageSizeSelector={true}
                showNavigationButtons={true}
                showInfo={true}
                displayMode={'compact'}
                visible={"totalCount > 0"}
                allowedPageSizes={DATAGRID_ALLOWED_PAGE_SIZES}
              />
              <ColumnChooser 
                enabled={true}
                mode='select'
              />
              <Column
                width={200}
                dataField="trackingCode"
                dataType="string"
                visible={true}
                caption={persianLanguage.word.general.TRACKING_CODE}
              />
              <Column
                width={200}
                dataField="description"
                dataType="string"
                visible={true}
                caption={persianLanguage.word.general.DESCRIPTION}
              />
              <Column
                width={150}
                dataField="approvedTitle"
                dataType="string"
                caption={persianLanguage.word.general.STATUS}
              />
              <Column
                dataField="transactionsCodes"
                dataType="string"
                visible={false}
                caption={persianLanguage.phrase.receipt.RECEIPT_RELATED_TRANSACTIONS_CODES}
              />
              <Column
                dataField="attachmentName"
                allowFiltering={false}
                dataType="string"
                allowSorting={false}
                visible={false}
                caption={persianLanguage.word.photo.PHOTO}
              />
                <Column
                dataField="createdBy"
                allowFiltering={false}
                dataType="date"
                allowSorting={false}
                visible={true}
                caption={persianLanguage.phrase.general.CREATED_BY}
              />
                <Column
                dataField="createdOn"
                allowFiltering={false}
                dataType="date"
                allowSorting={false}
                visible={true}
                caption={persianLanguage.phrase.general.CREATED_ON}
              />
            </DataGrid>
            <Popup
              visible={popupVisible}
              onHiding={hideInfo}
              dragEnabled={false}
              hideOnOutsideClick={true}
              showCloseButton={true}
              showTitle={true}
              title={persianLanguage.phrase.receipt.RECEIPT_DETAIL}
              width={`${windowWidth * 98/100}`}
              rtlEnabled={true}
              height={380}
              resizeEnabled={true}
            >
            <Position my="center" />
              <ReceiptDetail receiptId={receiptId} />
            </Popup>
            <ReceiptChangeApprovation 
              receipt={receipt} 
              approvePopupToParent={approvePopupToParent}
              approvedPopupVisible={approvedPopupVisible} />
          </div>            
          }

        </div>
      );
}